import { render, staticRenderFns } from "./origin.vue?vue&type=template&id=46e263c2&scoped=true"
import script from "./origin.vue?vue&type=script&lang=js"
export * from "./origin.vue?vue&type=script&lang=js"
import style0 from "./origin.vue?vue&type=style&index=0&id=46e263c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e263c2",
  null
  
)

export default component.exports